<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview" v-if="initData">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单号</label>
            <span class="weui-form-preview__value">{{initData.md_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">开工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.md_planbegindate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造类型</label>
            <span class="weui-form-preview__value">{{initData.md_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{initData.md_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.detail_pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单数量</label>
            <span class="weui-form-preview__value">{{initData.md_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单行号</label>
            <span class="weui-form-preview__value">{{initData.dd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位用量</label>
            <span class="weui-form-preview__value">{{initData.dd_oneuseqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.main_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.main_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料型号</label>
            <span class="weui-form-preview__value">{{initData.main_pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">可完工数量</label>
            <span class="weui-form-preview__value">{{initData.dd_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工数量</label>
            <span class="weui-form-preview__value">{{initData.dd_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工率%</label>
            <span class="weui-form-preview__value">{{initData.dd_maderate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">直通率%</label>
            <span class="weui-form-preview__value">{{initData.dd_ztrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">损耗金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.dd_losstotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">损耗率%</label>
            <span class="weui-form-preview__value">{{initData.dd_lossrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.md_actenddate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结案日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.md_enddate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>